export default __webpack_public_path__ + "static/media/background.3f42347a.png";